import { post, put, del, get, patch } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, {mutate} from 'swr'
import { handleApiResponse } from './api_util';

async function getAccountBalancesByCategory() {

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: 'accounts/balances_by_category'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}


export function useGetAccountBalancesByCategory(shouldFetch = true, options = {}) {
  const defaultOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    //refreshInterval: 0,
    //dedupingInterval: 10000,
  };

  const result = useSWR(
    shouldFetch ? 'ACCOUNT_BALANCES_BY_CATEGORY' : null,
    (path) => getAccountBalancesByCategory(),
    { ...defaultOptions, ...options }
  );
  return result;
}


export const updateAccount = async (accountId, updates) => {
  console.log('updateAccount firing', accountId)
  console.log(JSON.stringify(updates, null, 2))

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}`,
    options: {
      body: {
        account_data: updates,
      }
    }
  }
  console.log(`patching payload: ${JSON.stringify(payload)}`)
  const restOperation = patch(payload);


  const response = await restOperation.response;
  return processResponse(response)
};


export function useUpdateAccount() {
  return (accountId, updates) => {
    console.log('useUpdateAccount firing')
    const options = {
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: false,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      updateAccount(accountId, updates) // Call the update function
      , options);
  };
}

// Mark an account Personal or Business (categorization segments, Phase 2).
// The backend stamps it as a human decision, moves a bank/card account onto
// that ledger's chart and re-categorizes its transactions no one has reviewed.
export const updateAccountLedger = async (accountId, accountCategory) => {
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}/ledger`,
    options: {
      body: {
        account_category: accountCategory,
      }
    }
  }
  const restOperation = patch(payload);
  const response = await restOperation.response;
  return processResponse(response)
};

// Super-admin only: correct an account's identity fields (account_number,
// account_number_last4, sub_account_number, account_type). Backend enforces the
// Super Admins RBAC, the (last4, sub) uniqueness guard, and the expense-factor
// flip cascade. See .claude/references/account-identity-correction.md. NB: the
// identity payload carries account numbers (PII) — do NOT log the body.
export const updateAccountIdentity = async (accountId, identityData) => {
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}/identity`,
    options: {
      body: {
        identity_data: identityData,
      }
    }
  }
  const restOperation = patch(payload);
  const response = await restOperation.response;
  return processResponse(response)
};

// Super-admin only: merge an account INTO a survivor (re-links the merging
// side's balances to the survivor and tombstones the merged node). Backend
// enforces Super Admins RBAC. See account-identity-correction.md (ADR-001).
export const mergeAccount = async (mergedAccountId, survivorAccountId, reason, mergeKind) => {
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${mergedAccountId}/merge`,
    options: {
      body: {
        survivor_account_id: survivorAccountId,
        reason,
        merge_kind: mergeKind,
      }
    }
  }
  const restOperation = post(payload);
  const response = await restOperation.response;
  return processResponse(response)
};

export const updateLiability = async (accountId, liabilityId, updates) => {
  console.log('updateLiability firing')
  console.log(`accountId: ${accountId}`)
  console.log(`liabilityId: ${liabilityId}`)
  console.log(JSON.stringify(updates, null, 2))

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}/associated_liabilities/${liabilityId}`,
    options: {
      body: {
        associated_liability_data: updates,
      }
    }
  }
  console.log(`patching payload: ${JSON.stringify(payload)}`)
  const restOperation = patch(payload);


  const response = await restOperation.response;
  return processResponse(response)
};

export function useUpdateLiability() {
  return (accountId, liabilityId, updates) => {
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      updateLiability(accountId, liabilityId, updates) // Call the update function
      , options);
  };
}

export const deleteAccount = async (accountId) => {
  console.log('deleteAccount firing')
  console.log(`accountId: ${accountId}`)
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}`

  }

  const restOperation = del(payload);


  const response = await restOperation.response;

  return processResponse(response)
};

export function useDeleteAccount() {
  return (accountId) => {
    console.log('useDeleteAccount firing')
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      deleteAccount(accountId) // Call the delete function
      , options);
  };
}

export const deleteLiability = async (accountId, liabilityId) => {
  console.log('deleteLiability firing')
  console.log(`accountId: ${accountId}`)
  console.log(`liabilityId: ${liabilityId}`)
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}/associated_liabilities/${liabilityId}`

  }

  const restOperation = del(payload);


  const response = await restOperation.response;

  return processResponse(response)
};

export function useDeleteLiability() {
  return (accountId, liabilityId) => {
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      deleteLiability(accountId, liabilityId) // Call the delete function
      , options);
  };
}

export const createAccount = async (accountType, categoryName, accountData) => {

  console.log('createAccount firing')
  console.log(JSON.stringify(accountData, null, 2))

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: 'accounts',
    options: {
      body: {
        account_type: accountType,
        category_name: categoryName,
        account_data: accountData,
      }
    }
  }
  console.log(`posting payload: ${JSON.stringify(payload)}`)
  const restOperation = post(payload);


  const response = await restOperation.response;
  return processResponse(response)
};

export function useCreateAccount() {
  return (accountType, categoryName, accountData) => {
    console.log('useCreateAccount firing')
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      createAccount(accountType, categoryName, accountData) // Call the create function
      , options);
  };
}

export const createLiability = async (accountId, liabilityData) => {

  console.log('createLiability firing')
  console.log(`accountId: ${accountId}`)
  console.log('liabilityData:')
  console.log(JSON.stringify(liabilityData, null, 2))

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: `accounts/${accountId}/associated_liabilities`,
    options: {
      body: {
        associated_liability_data: liabilityData,
      }
    }
  }
  console.log(`posting payload: ${JSON.stringify(payload)}`)
  const restOperation = post(payload);


  const response = await restOperation.response;
  return processResponse(response)
};

export function useCreateLiability() {
  return (accountId, liabilityData) => {
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      createLiability(accountId, liabilityData) // Call the create function
      , options);
  };
}


async function updateAllAccounts(accountUpdates) {
  console.log('updateAllAccounts firing')
  // console.log(JSON.stringify(accountUpdates, null, 2))
  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: 'accounts/all',
    options: {
      body: {
        all_account_data: accountUpdates,
      }
    }
  }
  // console.log(`posting payload: ${JSON.stringify(payload)}`)
  const restOperation = post(payload);


  const response = await restOperation.response;
  return processResponse(response)
}

export function useUpdateAllAccounts() {
  return (accountUpdates) => {
    console.log('useUpdateAllAccounts firing')
    const options={
      optimisticData: accountUpdates, // Optimistically update the cache
      revalidate: false,
      populateCache: true, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      updateAllAccounts(accountUpdates) // Call the update function
      , options);
  };
}

async function deleteSettlementAdjustment() {
  console.log('deleteSettlementAdjustment firing')

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: 'accounts/settlement_adjustment',
  }
  const restOperation = del(payload);

  const response = await restOperation.response;
  return processResponse(response);
}

export function useDeleteSettlementAdjustment() {
  return () => {
    console.log('useDeleteSettlementAdjustment firing')
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      deleteSettlementAdjustment() // Call the delete function
      , options);
  };
}

async function mutateSettlementAdjustment(settlementAdjustmentData) {
  console.log('mutateSettlementAdjustment firing')
  console.log(JSON.stringify(settlementAdjustmentData, null, 2))

  const payload = {
    apiName: 'LivisiblyAccountApi',
    path: 'accounts/settlement_adjustment',
    options: {
      body: {
        settlement_adjustment_data: settlementAdjustmentData,
      }
    }
  }
  console.log(`posting payload: ${JSON.stringify(payload)}`)
  const restOperation = post(payload);
  const response = await restOperation.response;
  return processResponse(response)
}

export function useMutateSettlementAdjustment() {
  return (settlementAdjustmentData) => {
    console.log('useMutateSettlementAdjustment firing')
    const options={
      // optimisticData: optimisticData, // Optimistically update the cache
      revalidate: true,
      populateCache: false, // Use the returned data to update the cache
    }
    return mutate('ACCOUNT_BALANCES_BY_CATEGORY',
      mutateSettlementAdjustment(settlementAdjustmentData) // Call the create function
      , options);
  };
}